import { Permission, User } from '@hakimo-ui/hakimo/types';

export function hasPermission(user: User, permission: Permission) {
  return user.permissions.includes(permission);
}
